import { render, staticRenderFns } from "./ProdutoPesquisaAvancadaModal.vue?vue&type=template&id=738b0da7&scoped=true"
import script from "./ProdutoPesquisaAvancadaModal.vue?vue&type=script&lang=js"
export * from "./ProdutoPesquisaAvancadaModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoPesquisaAvancadaModal.vue?vue&type=style&index=0&id=738b0da7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b0da7",
  null
  
)

export default component.exports